import React from "react";
import DoctorFileRepositoryTable from "./DoctorFileRepositoryTable";

const DoctorFileRepository = () => {
  return <DoctorFileRepositoryTable></DoctorFileRepositoryTable>;
};

export default DoctorFileRepository;
